export enum InboxPageMobileView {
  ConversationList = 'ConversationList',
  MessageList = 'MessageList',
  RenterProfile = 'RenterProfile',
}
